import { render, staticRenderFns } from "./BuyPainting.vue?vue&type=template&id=ed5ed648&scoped=true"
import script from "./BuyPainting.vue?vue&type=script&lang=ts"
export * from "./BuyPainting.vue?vue&type=script&lang=ts"
import style0 from "./BuyPainting.vue?vue&type=style&index=0&id=ed5ed648&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ed5ed648",
  null
  
)

export default component.exports